import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { PopoverState, PopoverType } from 'modules/shop/popoverManager/types';

export const usePopoverManager = create(
  devtools<PopoverState>((set, getState) => ({
    activePopover: null,
    openPopover: (activePopover) => {
      const { activePopover: activePopoverInState, closePopover } = getState();

      activePopoverInState === activePopover
        ? closePopover()
        : set({ activePopover });
    },
    openSidebarPopover: () => {
      getState().openPopover(PopoverType.SIDEBAR);
    },
    closePopover: () => {
      set({ activePopover: null });
    },
  })),
);
